import React from 'react';

const VideosAnnonces = () => {
  const videos = [
    {
      url: 'https://customer-assets-agu9un31.emergentagent.net/job_dyvy-musicbox/artifacts/n2dlqbc1_Teaser%20Worship%20Instrumental%20%28Wi%29.mp4',
      title: 'Teaser Worship Instrumental'
    },
    {
      url: 'https://customer-assets-agu9un31.emergentagent.net/job_dyvy-musicbox/artifacts/47fqkanh_Teaser%20Cela%20prouve%20combien%20-%20Live%202023%20-%20Raoul%20Mavuna%20-%201080.mp4',
      title: 'Cela prouve combien - Live 2023'
    },
    {
      url: 'https://customer-assets-agu9un31.emergentagent.net/job_dyvy-musicbox/artifacts/eylcy6yw_Bandeke%20bako%20yembela%20Yo%20-%20Maman%20Christelle%20KATSHINGU%20feat%20Donel%20KATSHINGU%20-%201080.mp4',
      title: 'Bandeke bako yembela Yo'
    }
  ];

  return (
    <div className="w-full mt-8 mb-6 px-4">
      <h3 className="text-white text-center text-lg font-semibold mb-4">
        📢 Annonces / Publicités
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-6xl mx-auto">
        {videos.map((video, index) => (
          <div key={`video-${index}-${video.title}`} className="w-full">
            <video
              autoPlay
              muted
              loop
              playsInline
              className="w-full rounded-lg border border-[#E50914]"
              style={{ maxHeight: '300px', objectFit: 'cover' }}
            >
              <source src={video.url} type="video/mp4" />
              Vidéo non supportée
            </video>
            <p className="text-zinc-400 text-xs text-center mt-2">{video.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideosAnnonces;
